var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 49,
    viewBox: "0 0 38 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1904 30.1836C18.1592 30.1836 17.3154 31.0273 17.3154 32.0586C17.3154 33.0898 18.1592 33.9336 19.1904 33.9336C20.2217 33.9336 21.0654 33.0898 21.0654 32.0586C21.0654 31.0273 20.2217 30.1836 19.1904 30.1836Z",
    fill: "#22D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3779 20.8086V12.3711C31.3779 5.64453 25.917 0.183594 19.1904 0.183594C12.4521 0.183594 7.00293 5.64453 7.00293 12.3711V20.8086H0.44043V48.9336H37.9404V20.8086H31.3779ZM20.1279 35.6914V40.4961C20.1279 41.0117 19.7061 41.4336 19.1904 41.4336C18.6748 41.4336 18.2529 41.0117 18.2529 40.4961V35.6914C16.6357 35.2695 15.4404 33.8047 15.4404 32.0586C15.4404 29.9844 17.1162 28.3086 19.1904 28.3086C21.2646 28.3086 22.9404 29.9844 22.9404 32.0586C22.9404 33.8047 21.7451 35.2695 20.1279 35.6914ZM29.5029 20.8086H8.87793V12.3711C8.87793 6.6875 13.5068 2.05859 19.1904 2.05859C24.874 2.05859 29.5029 6.6875 29.5029 12.3711V20.8086Z",
    fill: "#22D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.21b128b76e458dce2438a6347983db30.svg";
export { ForwardRef as ReactComponent };